import type { TealiumEventData } from 'src/types/trackingData';

import { EVENT_NAME_INTERACTION } from '.';

const PREVIEW_OPENED = 'ecaja-job-previewed';
const PREVIEW_OPENED_INTERACTION = 'job-ad-preview';
export const PREVIEW_OPENED_EVENTDATA: TealiumEventData = {
  linkName: PREVIEW_OPENED,
  eventName: [PREVIEW_OPENED, EVENT_NAME_INTERACTION],
  objectInteraction: PREVIEW_OPENED_INTERACTION,
  actionOrigin: PREVIEW_OPENED_INTERACTION,
};

const PREVIEW_CLOSED = 'ecaja-job-preview-closed';
const PREVIEW_CLOSED_INTERACTION = 'job-ad-preview-closed';
export const PREVIEW_CLOSED_EVENTDATA: TealiumEventData = {
  linkName: PREVIEW_CLOSED,
  eventName: [EVENT_NAME_INTERACTION],
  objectInteraction: PREVIEW_CLOSED_INTERACTION,
};

const PREVIEW_TOGGLE_DETAILS = 'ecaja-preview-job-details-interacted';
export const PREVIEW_TOGGLE_DETAILS_EVENTDATA: TealiumEventData = {
  linkName: PREVIEW_TOGGLE_DETAILS,
  eventName: [PREVIEW_TOGGLE_DETAILS, EVENT_NAME_INTERACTION],
};

const PREVIEW_TOGGLE_SEARCH = 'ecaja-preview-search-results-interacted';
export const PREVIEW_TOGGLE_SEARCH_EVENTDATA: TealiumEventData = {
  linkName: PREVIEW_TOGGLE_SEARCH,
  eventName: [PREVIEW_TOGGLE_SEARCH, EVENT_NAME_INTERACTION],
};

const PREVIEW_PRINT_JOB_DETAILS = 'ecaja-preview-print-job-details';
export const PREVIEW_PRINT_JOB_DETAILS_EVENTDATA: TealiumEventData = {
  linkName: PREVIEW_PRINT_JOB_DETAILS,
  eventName: [PREVIEW_PRINT_JOB_DETAILS, EVENT_NAME_INTERACTION],
};

const PREVIEW_PRINT_SEARCH_RESULTS = 'ecaja-preview-print-search-results';
export const PREVIEW_PRINT_SEARCH_RESULTS_EVENTDATA: TealiumEventData = {
  linkName: PREVIEW_PRINT_SEARCH_RESULTS,
  eventName: [PREVIEW_PRINT_SEARCH_RESULTS, EVENT_NAME_INTERACTION],
};
